// Import model
import { Point } from '../models/Point';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for Point - handles JSON serialization and deserialization with type validation
 */
export class PointSerializer {
  /**
   * Deserializes a JSON string into a Point instance
   */
  static deserialize(json: string): Point {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a Point instance
   */
  static fromObject(obj: any): Point {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to Point');
    }


    const instance: Point = {
      x: obj['x'] as number | undefined,
      y: obj['y'] as number | undefined,
      z: obj['z'] as number | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of Point instances
   */
  static deserializeArray(json: string): Point[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a Point instance to a JSON string
   */
  static serialize(instance: Point): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a Point instance to a plain object
   */
  static toObject(instance: Point): any {
    return {
      'x': instance.x,
      'y': instance.y,
      'z': instance.z,
    };
  }

  /**
   * Serializes an array of Point instances to a JSON string
   */
  static serializeArray(instances: Point[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
